import JobTextRecordApi from '~/common/api/zeiterfassungServerApi/JobTextRecordApi';
import { Badge, Box, Heading } from '@chakra-ui/react';
import useTranslate from '~/common/utils/translate';
import { TextRecordsList } from './TextRecodsList';
import React from 'react';

export const TextRecords: React.FC = () => {
  const translate = useTranslate();
  const [{ data: recordCount }] = JobTextRecordApi.hooks.useTextRecordCount();
  return (
    <Box>
      <Heading mb={5}>
        {translate('dashboard.newtext')}
        <Badge
          marginLeft={5}
          variant="outline"
          colorScheme="green"
          fontSize={25}
        >
          {recordCount?.count ?? 0}
        </Badge>
      </Heading>
      <TextRecordsList />
    </Box>
  );
};
